import Button from '../common/Button';

const SubmitConfirmModal = ({ isOpen, onConfirm, onCancel, answeredCount, totalQuestions, loading }) => {
  if (!isOpen) return null;
  const unanswered = totalQuestions - answeredCount;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full mx-4 p-7 text-center animate-scale-in">
        {/* Icon */}
        <div className="w-14 h-14 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-7 h-7 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>

        <h2 className="text-lg font-bold text-slate-900 mb-1">Submit Exam?</h2>
        <p className="text-slate-500 text-sm mb-5">This action cannot be undone.</p>

        {/* Summary */}
        <div className="bg-slate-50 rounded-xl px-4 py-3 mb-4 text-sm text-left border border-slate-200 space-y-1.5">
          <div className="flex justify-between items-center">
            <span className="text-slate-500">Answered</span>
            <span className="font-semibold text-emerald-600">{answeredCount}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-slate-500">Unanswered</span>
            <span className={`font-semibold ${unanswered > 0 ? 'text-red-500' : 'text-slate-400'}`}>{unanswered}</span>
          </div>
          <div className="flex justify-between items-center pt-1 border-t border-slate-200">
            <span className="text-slate-500 font-medium">Total</span>
            <span className="font-semibold text-slate-700">{totalQuestions}</span>
          </div>
        </div>

        {unanswered > 0 && (
          <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5 mb-5 text-left">
            <svg className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <p className="text-xs text-amber-700">
              {unanswered} unanswered question{unanswered !== 1 ? 's' : ''} will be marked as unattempted.
            </p>
          </div>
        )}

        <div className="flex gap-3">
          <Button variant="secondary" onClick={onCancel} fullWidth disabled={loading}>
            Go Back
          </Button>
          <Button onClick={onConfirm} fullWidth loading={loading}>
            Submit Exam
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubmitConfirmModal;
